import { Link } from "react-router-dom";
import { useBrandName } from "@/lib/useBrandName";
import { SPORTS } from "@/lib/sports";
import { sportToSlug } from "@/lib/sportRoutes";

export default function Footer() {
    const brand = useBrandName();
    return (
        <footer data-testid="site-footer" className="border-t border-[#2a2a2a] mt-16">
            <div className="max-w-7xl mx-auto px-6 md:px-8 pt-8 pb-2">
                <div className="text-[10px] uppercase tracking-[0.2em] text-[#a0a0a0] mb-3">Browse by Sport &amp; State</div>
                <nav data-testid="footer-sport-links" className="flex flex-wrap gap-x-4 gap-y-2 text-[11px] uppercase tracking-[0.15em]">
                    {SPORTS.map((s) => (
                        <Link
                            key={s}
                            to={`/${sportToSlug(s)}`}
                            data-testid={`footer-sport-${sportToSlug(s)}`}
                            className="text-[#a0a0a0] hover:text-[#ff4500] transition-colors"
                        >
                            {s}
                        </Link>
                    ))}
                </nav>
            </div>
            <div className="max-w-7xl mx-auto px-6 md:px-8 py-8 grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
                <div>
                    <div data-testid="footer-brand" className="font-display text-xl tracking-wide text-white/90">{brand.toUpperCase()}</div>
                    <div className="text-[10px] uppercase tracking-[0.2em] text-[#a0a0a0] mt-1">
                        © 2026 — Find Your Team. Find Your Game.
                    </div>
                </div>
                <div className="text-[11px] text-[#a0a0a0] leading-relaxed md:text-center">
                    Independent directory. <span className="text-white">Not affiliated with any of the organizations, teams, trainers, or events listed</span>.
                    Trademarks belong to their respective owners.
                </div>
                <div className="flex md:justify-end gap-5 text-xs uppercase tracking-[0.2em]">
                    <Link to="/terms" data-testid="footer-terms" className="text-[#a0a0a0] hover:text-[#ff4500] transition-colors">Terms</Link>
                    <Link to="/privacy" data-testid="footer-privacy" className="text-[#a0a0a0] hover:text-[#ff4500] transition-colors">Privacy</Link>
                    <Link to="/contact" data-testid="footer-contact" className="text-[#a0a0a0] hover:text-[#ff4500] transition-colors">Contact</Link>
                </div>
            </div>
        </footer>
    );
}
